import {useState,useContext} from 'react';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
const Login = () => {
    const alert = useAlert();
    const navigate = useNavigate();
    const {loginUser, wait, loggedInCheck} = useContext(UserContext);
    const [redirect, setRedirect] = useState<string | false>(false);
    const [errMsg, setErrMsg] = useState<string | false>(false);
    const [formData, setFormData] = useState({
        email:'',
        password:''
    });

    const onChangeInput = (e: any) => {
        setFormData({
            ...formData,
            [e.target.name]:e.target.value
        })
    }

    const submitForm = async (e: any) => {
        e.preventDefault();

        if(!Object.values(formData).every(val => val.trim() !== '')){
            setErrMsg('Kérlek töltsd ki a kötelező mezőket.');
            return;
        }

        const data = await loginUser(formData);
        if(data.success){
            e.target.reset();
            setRedirect('Redirecting...');
            await loggedInCheck();
            return navigate('/');
        }
        alert.error("Helytelen felhasználónév vagy jelszó.")
        setErrMsg(data.message);
    }

    return (
        <div className="myform">
            <h2>Bejelentkezés</h2>
            <form onSubmit={submitForm}>
                <label htmlFor="email">Email:</label>
                <input type="email" name="email" onChange={onChangeInput} placeholder="Email" id="email" value={formData.email} required />
                <label htmlFor="password">Jelszó:</label>
                <input type="password" name="password" onChange={onChangeInput} placeholder="Jelszó" id="password" value={formData.password} required />
                {errMsg && <div className="err-msg">{errMsg}</div>}
                {redirect ? redirect : <button type="submit" disabled={wait}>Bejelentkezés</button>}
            </form>
        </div>
    )
}

export default Login;